/**
 * MUZI BATTLE — WebSocket client for online multiplayer battles.
 * Auto-reconnect, JSON message envelope, simple event listener API.
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function buildWsUrl(token) {
  const httpUrl = BACKEND_URL || window.location.origin;
  const wsBase = httpUrl.replace(/^http/, 'ws');
  return `${wsBase}/api/ws/battle?token=${encodeURIComponent(token)}`;
}

export function createBattleSocket(token, handlers = {}) {
  let ws = null;
  let manuallyClosed = false;

  const connect = () => {
    ws = new WebSocket(buildWsUrl(token));

    ws.onopen = () => {
      handlers.onOpen?.();
    };

    ws.onmessage = (e) => {
      let msg = null;
      try { msg = JSON.parse(e.data); } catch { return; }
      handlers.onMessage?.(msg);
    };

    ws.onerror = (err) => {
      handlers.onError?.(err);
    };

    ws.onclose = (e) => {
      handlers.onClose?.(e);
      if (!manuallyClosed && e.code !== 4001 && e.code !== 4002) {
        // Try reconnect after 2s
        setTimeout(() => {
          if (!manuallyClosed) connect();
        }, 2000);
      }
    };
  };

  connect();

  return {
    send(payload) {
      if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify(payload));
      }
    },
    joinQueue(mode) {
      this.send({ type: 'join_queue', mode });
    },
    leaveQueue() {
      this.send({ type: 'leave_queue' });
    },
    answer(word) {
      this.send({ type: 'answer', word });
    },
    skip() {
      this.send({ type: 'skip' });
    },
    close() {
      manuallyClosed = true;
      try { ws?.close(); } catch (err) {
        console.error('[battleSocket] close failed:', err);
      }
    },
    get state() {
      return ws?.readyState;
    },
  };
}
